import { render, staticRenderFns } from "./UserPhone.vue?vue&type=template&id=21e9661b&scoped=true&"
import script from "./UserPhone.vue?vue&type=script&lang=js&"
export * from "./UserPhone.vue?vue&type=script&lang=js&"
import style0 from "./UserPhone.vue?vue&type=style&index=0&id=21e9661b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e9661b",
  null
  
)

export default component.exports